module.exports = __webpack_public_path__ + "img/avatar-default-big.3712fbe8.png";